var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('nav-app-bar'),_c('nav-app-drawer'),_c('v-main',{staticStyle:{"background":"#eee"}},[_c('show-info'),_c('div',[_c('router-view')],1),_c('portal-target',{attrs:{"name":"v-main"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }